import React from "react";
import { Box, Typography } from "@mui/material";

const titleSx = { mt: 3, mb: 1, fontWeight: 700 };
const labelSx = { width: "200px", fontWeight: 700, flexShrink: 0 };
const valueSx = {
  flex: 1,
  borderBottom: "1px solid #999",
  minHeight: "20px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};
const rowSx = { display: "flex", gap: 12, mb: 1.2, alignItems: "flex-start" };

const boolText = (value) => {
  if (value === true) return "使用する";
  if (value === false) return "使用しない";
  return "";
};

const valueOrEmpty = (value) => value ?? "";

const Comp18PDF = ({ formData, boothNumber, companyName }) => {
  if (!formData) return null;

  const submission = formData.r18?.[0] ?? formData;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        キャッチコピー・ブース装飾
      </Typography>

      <Box sx={rowSx}>
        <Typography sx={labelSx}>小間番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.booth_number || formData.booth_number)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.company_name || formData.company_name)}</Box>
      </Box>

      <Typography sx={titleSx}>担当者情報</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>担当者名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_18_name || formData.user_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>部署</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_18_department || formData.department)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>会社電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_18_phone || formData.phone_number)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>携帯電話番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.user_18_tel)}</Box>
      </Box>

      <Typography sx={titleSx}>追加出展者証</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>出展者証追加枚数</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.additional_certs)}</Box>
      </Box>
      <Typography sx={titleSx}>キャッチコピー・ブース装飾</Typography>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>キャッチコピー</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.catchphrase)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>看板</Typography>
        <Box sx={valueSx}>{boolText(submission.basic_structure)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>パイプいす</Typography>
        <Box sx={valueSx}>{boolText(submission.basic_chair)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>側面パネル</Typography>
        <Box sx={valueSx}>{boolText(submission.side_panel)}</Box>
      </Box>

      <Typography sx={titleSx}>備考</Typography>
      <Box sx={valueSx}>{valueOrEmpty(submission.alfa_text)}</Box>
    </Box>
  );
};

export default Comp18PDF;
